import React from 'react';

import { styled as muiStyled } from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';

// 💡ボールドにする場合は Children で <strong> を使用する
// <DialogTitle><strong>...</strong></DialogTitle>
const StyledTitle = muiStyled(MuiDialogTitle)(
  ({ theme }) => `
  padding: ${theme.spacing(4)};
`,
);

export default StyledTitle;
